import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import { jsx, jsxs } from 'react/jsx-runtime';
import styled, { keyframes } from 'styled-components';
import { Text } from '@dls/web';
import { SCContainer, SCIconContainer, SCLoadingTextContainer } from './styles.js';
const Loading = _ref => {
  let {
    size = "md",
    showText = false
  } = _ref;
  return /* @__PURE__ */jsx(SCContainer, {
    children: /* @__PURE__ */jsxs(SCIconContainer, {
      children: [/* @__PURE__ */jsx(LoadingIcon, {
        size: calcSize(size)
      }), showText && /* @__PURE__ */jsx(SCLoadingTextContainer, {
        children: /* @__PURE__ */jsx(Text, {
          type: size === "sm" ? "smallBody" : "body",
          children: "Loading..."
        })
      })]
    })
  });
};
const LoadingIcon = _ref2 => {
  let {
    size
  } = _ref2;
  return /* @__PURE__ */jsx(LoadingSpinner, {
    $size: size,
    children: /* @__PURE__ */jsx(LoadingContent, {
      $scale: size / 100,
      children: /* @__PURE__ */jsx("div", {})
    })
  });
};
const calcSize = size => {
  switch (size) {
    case "xs":
      return 24;
    case "sm":
      return 32;
    case "md":
      return 48;
    case "lg":
      return 64;
    default:
      return 48;
  }
};
const LoadingSpinner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  display: inline-block;\n  overflow: hidden;\n  background: none;\n"])), props => props.$size, props => props.$size);
const spin = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% { \n    transform: translate(-50%,-50%) rotate(0deg); \n  }\n\n  100% { \n    transform: translate(-50%,-50%) rotate(360deg); \n  }\n"])));
const LoadingContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform: translateZ(0) scale(", ");\n  backface-visibility: hidden;\n  transform-origin: 0 0;\n\n  div {\n    box-sizing: content-box;\n    animation: ", " 1s linear infinite;\n    top: 50px;\n    left: 50px;\n\n    position: absolute;\n    width: 74px;\n    height: 74px;\n    border: 6px solid #ed1a3d;\n    border-top-color: transparent;\n    border-radius: 50%;\n  }\n"])), props => props.$scale, spin);
export { Loading as default };